/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pipelines_TeamInputs */

const cs_pipelines_team = /** @type {(inputs: Pipelines_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tým (volitelně)`)
};

const en_pipelines_team = /** @type {(inputs: Pipelines_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Team (optional)`)
};

/**
* | output |
* | --- |
* | "Team (optional)" |
*
* @param {Pipelines_TeamInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const pipelines_team = /** @type {((inputs?: Pipelines_TeamInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pipelines_TeamInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pipelines_team(inputs)
	return cs_pipelines_team(inputs)
});